import { NextPage } from 'next';
import { useRouter } from 'next/router';
import AppBottomNavigation from '@/containers/AppBottomNavigation';
import GoyoloPolicy from '@/components/GoyoloPolicy';

const GoyoloPolicyPage: NextPage = () => {
  const { back } = useRouter();
  return (
    <>
      <GoyoloPolicy onGoBack={back} />
      <AppBottomNavigation />
    </>
  );
};

export default GoyoloPolicyPage;
